var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33,
  _t34,
  _t35,
  _t36,
  _t37,
  _t38,
  _t39,
  _t40,
  _t41,
  _t42,
  _t43,
  _t44,
  _t45;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as dayjs from 'dayjs';
import 'dayjs/locale/lb';
import { LitElement, html } from 'lit';
import css from './style.pcss';
import translations from "./translations";
import datepicker from 'js-datepicker';
import Flickity from "flickity";
import { helper } from "../../common/helper";
import PauseButtonIcon from "../../common/images/btn_pause.svg";
import ReplayButtonIcon from "../../common/images/btn_replay.svg";
import TickerButtonIcon from "../../common/images/btn_ticker.svg";
import LiveButtonIcon from "../../common/images/btn_live.svg";
import LiveTickerButtonIcon from "../../common/images/btn_liveticker.svg";
import LiveArenaButtonIcon from "../../common/images/btn_livearena.svg";
import HighlightsButtonIcon from "../../common/images/btn_highlights.svg";
import ApartLogo from "../../common/images/aparttv_btn.svg";
import GoldLiveButtonIcon from "../../common/images/btn_live_gold.svg";
import GoldLiveArenaButtonIcon from "../../common/images/btn_livearena_gold.svg";
import GoldReplayButtonIcon from "../../common/images/btn_replay_gold.svg";
import BasketballIcon from "./images/icon_basketball.svg";
import CyclingIcon from "./images/icon_cycling.svg";
import FootballIcon from "./images/icon_football.svg";
import HandballIcon from "./images/icon_handball.svg";
import TableTennisIcon from "./images/icon_table-tennis.svg";
import VolleyballIcon from "./images/icon_volleyball.svg";
var SportIcons = {
  basketball: BasketballIcon,
  cycling: CyclingIcon,
  football: FootballIcon,
  handball: HandballIcon,
  "table-tennis": TableTennisIcon,
  volleyball: VolleyballIcon
};
var RTLLiveArena = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLLiveArena, _LitElement);
  function RTLLiveArena() {
    var _this;
    _classCallCheck(this, RTLLiveArena);
    _this = _callSuper(this, RTLLiveArena);
    _this.hideTabs = false;
    _this.alreadyFetchedDisabledMonths = [];
    _this.language = 'lu';
    _this.type = 'large';
    _this.types = ['football', 'basketball', 'handball', 'volleyball', 'table-tennis', 'cycling'];
    _this.typeTranslations = {
      'all': "All",
      'football': 'Fussball',
      'basketball': 'Basketball',
      'handball': 'Handball',
      'volleyball': 'Volleyball',
      'table-tennis': 'Dëschtennis',
      'cycling': 'Velo'
    };
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 30000);
    _this.activeTab = "program";
    _this.filterSportType = "all";
    _this.aparttvMatches = [];
    _this.sortOrder = "sport";
    _this.replayStartDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
    _this.replayEndDate = dayjs().format('YYYY-MM-DD');
    _this.currentDate = undefined;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    _this.apiUrl = "https://www.rtl.lu";
    dayjs.locale('lb');
    return _this;
  }
  _createClass(RTLLiveArena, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLLiveArena.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "_fetchDates",
    value: function _fetchDates(month, year) {
      return fetch(`${this.apiUrl}/api/sportstream/dates?year=${year}&month=${month}&source=live-arena`).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "_fetchLivestreams",
    value: function () {
      var _fetchLivestreams2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var startDate, endDate, dataAPI, resp, countEntries;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              startDate = dayjs().format('YYYY-MM-DD');
              endDate = dayjs().add(7, 'day').format('YYYY-MM-DD');
              dataAPI = `${this.apiUrl}/api/sportstream/livestreams?start_date=${startDate}&end_date=${endDate}&types=${this.types.join(',')}&source=live-arena`;
              _context.prev = 3;
              _context.next = 6;
              return fetch(dataAPI).then(function (resp) {
                return resp.json();
              });
            case 6:
              resp = _context.sent;
              countEntries = 0;
              Object.keys(resp).forEach(function (sport) {
                countEntries += Object.keys(resp[sport]).length;
              });
              if (countEntries === 0) {
                this.activeTab = "replay";
                this.hideTabs = true;
              }
              this.data = resp;
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              if (this.interval) clearInterval(this.interval);
              console.log('ERROR: ', _context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 13]]);
      }));
      function _fetchLivestreams() {
        return _fetchLivestreams2.apply(this, arguments);
      }
      return _fetchLivestreams;
    }()
  }, {
    key: "_fetchReplay",
    value: function () {
      var _fetchReplay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var dataAPI, resp;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              dataAPI = `${this.apiUrl}/api/sportstream/livestreams?start_date=${this.replayStartDate}&end_date=${this.replayEndDate}&types=${this.types.join(',')}&source=live-arena`;
              _context2.prev = 1;
              _context2.next = 4;
              return fetch(dataAPI).then(function (resp) {
                return resp.json();
              });
            case 4:
              resp = _context2.sent;
              this.replayData = resp;
              _context2.next = 12;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              if (this.interval) clearInterval(this.interval);
              console.log('ERROR: ', _context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 8]]);
      }));
      function _fetchReplay() {
        return _fetchReplay2.apply(this, arguments);
      }
      return _fetchReplay;
    }()
  }, {
    key: "_fetchApart",
    value: function () {
      var _fetchApart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var matchDates, apartResp;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              matchDates = [];
              Object.keys(this.data).forEach(function (sportKey) {
                var sportData = _this2.data[sportKey];
                Object.keys(sportData).forEach(function (competitionKey) {
                  var competitionData = sportData[competitionKey];
                  matchDates = [].concat(_toConsumableArray(matchDates), _toConsumableArray(Object.keys(competitionData.entries)));
                });
              });
              Object.keys(this.replayData).forEach(function (sportKey) {
                var sportData = _this2.data[sportKey];
                Object.keys(sportData).forEach(function (competitionKey) {
                  var competitionData = sportData[competitionKey];
                  matchDates = [].concat(_toConsumableArray(matchDates), _toConsumableArray(Object.keys(competitionData.entries)));
                });
              });
              matchDates = _toConsumableArray(new Set(matchDates)); // make unique
              if (!(matchDates.length > 0)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return fetch("https://api-gate.rtl.lu/sport/apart-tv?dates=" + matchDates.join(",")).then(function (apartResp) {
                return apartResp.json();
              });
            case 7:
              apartResp = _context3.sent;
              this.aparttvMatches = apartResp;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _fetchApart() {
        return _fetchApart2.apply(this, arguments);
      }
      return _fetchApart;
    }()
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this._fetchLivestreams();
            case 2:
              _context4.next = 4;
              return this._fetchReplay();
            case 4:
              _context4.next = 6;
              return this._fetchApart();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _fetchData() {
        return _fetchData2.apply(this, arguments);
      }
      return _fetchData;
    }()
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getLink",
    value: function _getLink(sportid) {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('link-' + sportid)}/resultater`;
      return link;
    }
  }, {
    key: "_showLiveticker",
    value: function _showLiveticker(e, match, summary, sportType) {
      if (match.info === "postponed") return;
      var mapping = {
        "football": 1,
        "basketball": 2,
        "handball": 3,
        "volleyball": 4,
        "table-tennis": 5
      };
      helper.openLivearenaLink(match.id, summary, mapping[sportType], match.has_ticker);
    }
  }, {
    key: "shouldShowApartButton",
    value: function shouldShowApartButton(match) {
      var ret = false;
      this.aparttvMatches.some(function (apart) {
        if (match.home_team.id == apart.home_team && match.visitor_team.id == apart.guest_team && match.date === apart.date && apart.time == match.hour) {
          var date = dayjs(`${apart.date} ${apart.time}`).add(2, 'hour');
          var now = dayjs();
          ret = now.isBefore(date) || match.is_live;
        }
      });
      return ret;
    }
  }, {
    key: "_renderItem",
    value: function _renderItem(item, sporttype) {
      var _this3 = this;
      switch (item.type) {
        case 'live-arena':
          var match = item.video.match;
          var isRowClickable = false;
          var shouldShowApartButton = this.shouldShowApartButton(match);
          var icon, matchLink;
          if (sporttype) {
            this.link = this._getLink(sporttype);
            matchLink = `${this.link}/national/match?m=${match.id}`;
          }
          if (match.is_paused) {
            icon = html(_t || (_t = _`<img src="${0}" alt="button more"/>`), PauseButtonIcon);
          } else {
            var isLive = match.is_live;
            var hasTicker = match.has_ticker;
            var wasPlayed = match.was_played;
            var hasId = !match.live_arena_hidden && (match.live_arena_id || match.live_arena_replay_id || match.live_arena_livestream_id);
            var isGold = match.live_arena_top_match;
            if (hasTicker) icon = html(_t2 || (_t2 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), TickerButtonIcon);
            if (hasTicker && isLive) icon = html(_t3 || (_t3 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveTickerButtonIcon);
            if (hasId) icon = html(_t4 || (_t4 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldLiveArenaButtonIcon : LiveArenaButtonIcon);
            if (wasPlayed && hasId) icon = html(_t5 || (_t5 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldReplayButtonIcon : ReplayButtonIcon);
            if (isLive && hasId) icon = html(_t6 || (_t6 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldLiveButtonIcon : LiveButtonIcon);
            if (shouldShowApartButton) icon = html(_t7 || (_t7 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), ApartLogo);
            if (match.info === "postponed") icon = null;
          }
          isRowClickable = !!icon;
          var iconSummary;
          if (match.live_arena_summary_url) iconSummary = html(_t8 || (_t8 = _`<span @click=${0}><img class="results-table__button-highlights" src="${0}" alt="button more"/></span>`), function (e) {
            return _this3._showLiveticker(e, match.id, true);
          }, HighlightsButtonIcon);
          if (!match.live_arena_hidden) {
            var sportTypeColumn = null;
            if (this.sortOrder === "date") {
              sportTypeColumn = html(_t9 || (_t9 = _`<div class="livearena-row__sporttype">
                        <img class="livearena-row__sporttype-img" src=${0} />

                        </div>`), `${SportIcons[item.sport_slug]}`);
            }
            return html(_t10 || (_t10 = _`

                        <div class="livearena-row livearena-row--${0}${0}">
                            ${0}
                            <div class="livearena-row__content">
                                <div class="livearena-row__date">
                                    ${0}<br>
                                    <span>${0}</span>
                                </div>

                                <div class="livearena-row__team livearena-row__team--home" @click=${0}>
                                    <div class="livearena-row__logo">${0}</div>
                                    <span class="livearena-row__teamname">${0}</span>
                                    <span class="livearena-row__shortteamname">${0}</span>
                                </div>
                                <div class="livearena-row__score" @click=${0}>
                                    <div class="livearena-row__scoretext">
                                        ${0}
                                    </div>
                                    <div class="livearena-row__button">
                                        ${0}
                                        ${0}
                                    </div>
                                </div>
                                <div class="livearena-row__team livearena-row__team--visitor" @click=${0}>
                                    <span class="livearena-row__teamname">${0}</span>
                                    <span class="livearena-row__shortteamname">${0}</span>
                                    <div class="livearena-row__logo">${0}</div>
                                </div>
                            <div>
                        </div>

                    `), item.type, match.is_live ? ' livearena-row--islive' : '', sportTypeColumn, match.hour, dayjs(match.date).format('DD/MM/YY'), function (e) {
              return _this3._showLiveticker(e, match, false, sporttype);
            }, match.home_team.logo_url ? html(_t11 || (_t11 = _`<img src="${0}" border="0" alt="${0}" />`), match.home_team.logo_url, match.home_team.name) : '', match.home_team.name, match.home_team.short_name, function (e) {
              return _this3._showLiveticker(e, match, false, sporttype);
            }, match.was_played ? html(_t12 || (_t12 = _`${0} : ${0}`), match.home_score, match.visitor_score) : html(_t13 || (_t13 = _`<span>VS</span>`)), icon, iconSummary, function (e) {
              return _this3._showLiveticker(e, match, false, sporttype);
            }, match.visitor_team.name, match.visitor_team.short_name, match.visitor_team.logo_url ? html(_t14 || (_t14 = _`<img src="${0}" border="0" alt="${0}" />`), match.visitor_team.logo_url, match.visitor_team.name) : '');
          } else {
            return null;
          }
        default:
          return html(_t15 || (_t15 = _`
                    <div class="livearena-row livearena-row--${0}${0}">
                        <div class="livearena-row__date">
                            ${0}<br>
                            <span>${0}</span>
                        </div>

                        <div class="livearena-row__title">
                            ${0}
                        </div>
                    </div>
                `), item.type, item.is_live ? ' livearena-row--islive' : '', dayjs(item.date).format('HH:mm'), dayjs(item.date).format('DD/MM/YY'), item.title);
      }
    }
  }, {
    key: "_renderCompetitions",
    value: function _renderCompetitions(items, type) {
      var _this4 = this;
      if (!items) return;
      var output = [];
      var streamItems = Object.keys(items);
      for (var _i = 0, _streamItems = streamItems; _i < _streamItems.length; _i++) {
        var stream = _streamItems[_i];
        if (Object.keys(items[stream].entries).length === 0 && Object.keys(items[stream].entries.constructor === Object)) continue;
        if (items[stream].competition) output.push(html(_t16 || (_t16 = _`<div class="livearena-table__competition">${0}</div>`), items[stream].competition.name));else output.push(html(_t17 || (_t17 = _`<div class="livearena-table__competition">Aner Streamen</div>`)));
        var dates = Object.keys(items[stream].entries);
        for (var _i2 = 0, _dates = dates; _i2 < _dates.length; _i2++) {
          var date = _dates[_i2];
          ;
          var entries = items[stream].entries[date];
          entries = entries.sort(function (a, b) {
            return dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1;
          });
          if (entries.length > 0) {
            output.push(html(_t18 || (_t18 = _`<div class="livearena-table__date">${0}</div>`), dayjs(date).format('DD. MMMM YYYY')));
            console.log("ENTRIES", entries);
            entries.map(function (item) {
              return output.push(_this4._renderItem(item, type));
            });
          }
        }
      }
      return output;
    }
  }, {
    key: "_renderSports",
    value: function _renderSports(data) {
      var _this5 = this;
      if (data === undefined) return html(_t19 || (_t19 = _`Loading...`));
      if (this.filterSportType !== "all" && Object.keys(data[this.filterSportType]).length === 0) {
        return html(_t20 || (_t20 = _`<div>Leider keng donnéen</div>`));
      }
      if (this.sortOrder === "date") {
        var allEntries = [];
        Object.keys(data).map(function (sport) {
          if (_this5.filterSportType !== "all" && sport !== _this5.filterSportType) return false;
          Object.keys(data[sport]).map(function (competition) {
            Object.keys(data[sport][competition].entries).map(function (date) {
              allEntries = [].concat(_toConsumableArray(allEntries), _toConsumableArray(data[sport][competition].entries[date]));
            });
          });
        });
        allEntries = allEntries.sort(function (a, b) {
          return dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1;
        });
        return html(_t21 || (_t21 = _`<div>
            ${0}
            </div>`), allEntries.map(function (entry) {
          return _this5._renderItem(entry, "football");
        }));
      }
      return html(_t22 || (_t22 = _`
            <div class="livearena-table">
            ${0}
            </div>
        `), this.types.map(function (type) {
        if (data[type] && Object.keys(data[type]).length > 0) {
          if (_this5.filterSportType !== "all" && _this5.filterSportType !== type) return null;
          var output = _this5._renderCompetitions(data[type], type);
          if (output.length > 0) {
            return html(_t23 || (_t23 = _`
                            <div class="livearena-table__head">
                                ${0}
                                <div class="livearena-table__head--sponsor">
                                    <div class="ad-slot ad-slot--table-sponsor">
                                        <div class="ad-slot__table-sponsor">
                                            <div id="table-sponsor-home-${0}" class="js-ad"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ${0}
                        `), _this5._getTranslation(type), type, _this5._renderCompetitions(data[type], type));
          }
        }
      }));
    }
  }, {
    key: "_renderHighlight",
    value: function _renderHighlight(item, sporttype) {
      switch (item.type) {
        case 'live-arena':
          var match = item.video.match;
          var icon, matchLink;
          if (match.is_paused) {
            icon = html(_t24 || (_t24 = _`<img src="${0}" alt="button more"/>`), PauseButtonIcon);
          } else {
            if (match.was_played && (match.live_arena_id || match.live_arena_replay_id || match.live_arena_livestream_id) && match.has_details && !match.live_arena_hidden) icon = html(_t25 || (_t25 = _`<img src="${0}" alt="button more"/>`), ReplayButtonIcon);
            if (match.was_played && match.has_details && match.live_arena_hidden) icon = html(_t26 || (_t26 = _`<img src="${0}" alt="button more"/>`), TickerButtonIcon);
            if (match.is_live && (match.live_arena_id || match.live_arena_replay_id || match.live_arena_livestream_id)) icon = html(_t27 || (_t27 = _`<img src="${0}" alt="button more"/>`), LiveButtonIcon);
            if (match.is_live && !(match.live_arena_id || match.live_arena_replay_id || match.live_arena_livestream_id)) icon = html(_t28 || (_t28 = _`<img src="${0}" alt="button more"/>`), LiveTickerButtonIcon);
            //if (!match.was_played && !match.has_details && !match.is_live && match.live_arena_id && !match.live_arena_hidden) icon = html`<img src="${LiveArenaButtonIcon}" alt="button more"/>`;
          }
          if (sporttype) {
            this.link = this._getLink(sporttype);
            matchLink = `${this.link}/national/match?m=${match.id}`;
          }
          if (match.live_arena_id && !match.live_arena_hidden) {
            return html(_t29 || (_t29 = _`

                        <div class="rtl-live-arena-hl rtl-live-arena-hl--${0}${0}">
                            ${0}
                            <div class="rtl-live-arena-hl__content">
                                <div class="rtl-live-arena-hl__team rtl-live-arena-hl__team--home">
                                    <div class="rtl-live-arena-hl__logo">${0}</div>
                                    <span class="rtl-live-arena-hl__teamname">${0}</span>
                                </div>
                                <div class="rtl-live-arena-hl__score">
                                    <div class="rtl-live-arena-hl__date">
                                        ${0}<br>
                                        <span>${0}</span>
                                    </div>
                                    ${0}
                                    <div class="rtl-live-arena-hl__button">
                                        ${0}
                                    </div>
                                </div>
                                <div class="rtl-live-arena-hl__team livearena-row__team--visitor">
                                    <div class="rtl-live-arena-hl__logo">${0}</div>
                                    <span class="rtl-live-arena-hl__teamname">${0}</span>
                                </div>
                            </div>

                            ${0}
                        </div>

                    `), item.type, match.is_live ? ' livearena-row--islive' : '', item.sport_slug ? html(_t30 || (_t30 = _`
                                <div class="rtl-live-arena-hl__head">${0}</div>
                                `), this._getTranslation(item.sport_slug)) : '', match.home_team.logo_url ? html(_t31 || (_t31 = _`<img src="${0}" border="0" alt="${0}" />`), match.home_team.logo_url, match.home_team.name) : '', match.home_team.name, match.hour, dayjs(match.date).format('DD/MM/YY'), match.was_played ? html(_t32 || (_t32 = _`${0} : ${0}`), match.home_score, match.visitor_score) : html(_t33 || (_t33 = _`<span>VS</span>`)), icon, match.visitor_team.logo_url ? html(_t34 || (_t34 = _`<img src="${0}" border="0" alt="${0}" />`), match.visitor_team.logo_url, match.visitor_team.name) : '', match.visitor_team.name, matchLink ? html(_t35 || (_t35 = _`<a href="${0}" class="block-link__overlay"></a>`), matchLink) : '');
          } else {
            return null;
          }
        default:
          return html(_t36 || (_t36 = _`
                    <div class="rtl-live-arena-hl rtl-live-arena-hl--${0}${0}">
                            <div class="rtl-live-arena-hl__date">
                                ${0}<br>
                                <span>${0}</span>
                            </div>

                            <div class="rtl-live-arena-hl__title">
                                ${0}
                            </div>
                        </div>
                `), item.type, item.is_live ? ' livearena-row--islive' : '', dayjs(item.date).format('HH:mm'), dayjs(item.date).format('DD/MM/YY'), item.title);
      }
    }
  }, {
    key: "_renderHighlights",
    value: function _renderHighlights() {
      var _this6 = this;
      return this.highlights.map(function (hl) {
        return html(_t37 || (_t37 = _`
                <div class="slider__item rtl-live-arena-hl">
                    ${0}
                </div>
            `), _this6._renderHighlight(hl, hl.sport_slug));
      });
    }
  }, {
    key: "_handleReset",
    value: function _handleReset(e) {
      var elm = this.querySelector('.rtl-live-arena__datepicker');
      elm.value = "";
      this.dateSet = false;
      this.startDate = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.endDate = dayjs().add(5, 'day').format('YYYY-MM-DD');
      this.picker.setDate();
      this._fetchData();
    }
  }, {
    key: "_handleChangeMonth",
    value: function () {
      var _handleChangeMonth2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
        var prevMonth, dates, disabledDates;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // et muss een emmer schon den Mount virdrun fetchen goen well en soss näischt unweist
              prevMonth = dayjs(`${e.currentYear}-${e.currentMonth + 1}-01`).subtract(1, "month");
              if (!(this.alreadyFetchedDisabledMonths.includes(prevMonth.format("YYYY-MM")) || prevMonth.isAfter(dayjs()))) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", false);
            case 3:
              _context5.next = 5;
              return this._fetchDates(prevMonth.format("MM"), prevMonth.format("YYYY"));
            case 5:
              dates = _context5.sent;
              disabledDates = this.picker.disabledDates;
              if (dates) {
                dates.inactive.map(function (date) {
                  disabledDates[dayjs(date).valueOf()] = 1;
                });
              }
              this.picker.disabledDates = disabledDates;
              this.alreadyFetchedDisabledMonths.push(prevMonth.format("YYYY-MM"));
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _handleChangeMonth(_x) {
        return _handleChangeMonth2.apply(this, arguments);
      }
      return _handleChangeMonth;
    }()
  }, {
    key: "changeTab",
    value: function changeTab(tab) {
      this.activeTab = tab;
      this.filterSportType = "all"; // Sënnvoll?
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(changedProperties) {
        var _this7 = this;
        var dPicker, dates1, dates2, dates3, disabledDates;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // Datepicker
              dPicker = this.querySelector('.rtl-live-arena__datepicker');
              _context6.next = 3;
              return this._fetchDates(dayjs().subtract(2, 'month').month() + 1, dayjs().subtract(2, 'month').year());
            case 3:
              dates1 = _context6.sent;
              _context6.next = 6;
              return this._fetchDates(dayjs().subtract(1, 'month').month() + 1, dayjs().subtract(1, 'month').year());
            case 6:
              dates2 = _context6.sent;
              _context6.next = 9;
              return this._fetchDates(dayjs().month() + 1, dayjs().year());
            case 9:
              dates3 = _context6.sent;
              this.alreadyFetchedDisabledMonths = [`${dayjs().subtract(2, 'month').format("YYYY-MM")}`, `${dayjs().subtract(1, 'month').format("YYYY-MM")}`, `${dayjs().format("YYYY-MM")}`];
              disabledDates = [];
              if (dates1 && dates2 && dates3) {
                dates1.inactive.map(function (date) {
                  disabledDates.push(new Date(date));
                });
                dates2.inactive.map(function (date) {
                  disabledDates.push(new Date(date));
                });
                dates3.inactive.map(function (date) {
                  disabledDates.push(new Date(date));
                });
              }
              this.picker = datepicker(dPicker, {
                customDays: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
                customMonths: ['Jan', 'Feb', 'Mär', 'Abr', 'Mee', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dez'],
                disabledDates: disabledDates,
                maxDate: new Date(dayjs().subtract(1, "day")),
                // Jan 1st, 2099.
                // minDate: new Date(dayjs().startOf('month').subtract(2, 'month')), // June 1st, 2016.
                onSelect: function onSelect(instance, date) {
                  _this7.replayStartDate = dayjs(date).format('YYYY-MM-DD');
                  _this7.replayEndDate = dayjs(date).format('YYYY-MM-DD');
                  _this7.dateSet = true;
                  _this7._fetchData();
                },
                onMonthChange: function onMonthChange(e) {
                  _this7._handleChangeMonth(e);
                },
                formatter: function formatter(input, date, instance) {
                  input.value = dayjs(date).format('DD/MM/YYYY');
                }
              });
              this.picker.calendarContainer.style.setProperty('font-size', '0.9rem');

              // Highlights

              // if (this.highlights.length > 0) {
              //     const hlContainer = this.querySelector('.rtl-live-arena-hls');
              //
              //     if (!this.flickity && hlContainer) {
              //         this.flickity = new Flickity(hlContainer, {
              //             groupCells: true,
              //             wrapAround: false,
              //             cellAlign: 'center',
              //             imagesLoaded: true,
              //             pageDots: false,
              //             on: {
              //                 ready: function() {
              //                     hlContainer.classList.add("rtl-live-arena-hls--visible");
              //                     if (this.cells.length <= 3) hlContainer.classList.add("rtl-live-arena-hl--hideprevnext");
              //                 }
              //             }
              //         });
              //     }
              // }
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function firstUpdated(_x2) {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
  }, {
    key: "renderSportSelector",
    value: function renderSportSelector(data) {
      var _this8 = this;
      return html(_t38 || (_t38 = _`Sportaarten: <select @change=${0}>
            ${0}
        </select>`), function (e) {
        return _this8.filterSportType = e.target.value;
      }, Object.keys(this.typeTranslations).map(function (type) {
        var isSelected = _this8.filterSportType === type;
        var isEnabled = false;
        if (data) isEnabled = type === "all" || data[type] && Object.keys(data[type]).length > 0;
        return html(_t39 || (_t39 = _`<option ?disabled=${0} ?selected=${0} value=${0}>${0}</option>`), !isEnabled, isSelected, type, _this8.typeTranslations[type]);
      }));
    }
  }, {
    key: "renderSortSelector",
    value: function renderSortSelector() {
      var _this9 = this;
      return html(_t40 || (_t40 = _`Sortéiren no: <select @change=${0}>
            <option ?selected=${0} value="sport">Sport</option>
            <option ?selected=${0} value="date">Datum</option>
        </select>`), function (e) {
        return _this9.sortOrder = e.target.value;
      }, this.sortOrder === "sport" ? true : false, this.sortOrder === "date" ? true : false);
    }
  }, {
    key: "renderProgramm",
    value: function renderProgramm() {
      var isActive = this.activeTab === "program";
      return html(_t41 || (_t41 = _`<div class=${0}>
            <div class="rtl-live-arena-streams">
                <h1 class="rtl-live-arena__title">Programm nächst 7 Deeg</h1>
                <div class="rtl-live-arena__filterbar-container">
                    <div class="rtl-live-arena__filterbar">
                        <!-- <input class="rtl-live-arena__datepicker" type="text" placeholder="Datum wielen..." readonly="readonly" /> -->
                            <div class="rtl-live-arena__filter-select">${0}</div>
                            <div class="rtl-live-arena__filter-select rtl-live-arena__filter-select--margin">${0}</div>
                    </div>
                </div>
                ${0}
            </div>
        </div>`), "rtl-live-arena" + (!isActive ? " hide-element" : ""), this.renderSortSelector(), this.renderSportSelector(this.data), this._renderSports(this.data));
    }
  }, {
    key: "renderReplay",
    value: function renderReplay() {
      var isActive = this.activeTab === "replay";
      return html(_t42 || (_t42 = _`<div class=${0}>
            <div class="rtl-live-arena-streams">
                <h1 class="rtl-live-arena__title">Replay</h1>
                <div class="rtl-live-arena__filterbar-container">
                    <div class="rtl-live-arena__filterbar">
                        <input class="rtl-live-arena__datepicker" type="text" placeholder="Spezifeschen Datum" />
                        <div class="rtl-live-arena__filter-select">${0}</div>
                        <div class="rtl-live-arena__filter-select rtl-live-arena__filter-select--margin">${0}</div>
                        <!-- // ${0} -->
                    </div>
                </div>
                ${0}
            </div>
        </div>`), "rtl-live-arena" + (!isActive ? " hide-element" : ""), this.renderSortSelector(), this.renderSportSelector(this.replayData), this.dateSet ? html(_t43 || (_t43 = _`<button class="rtl-live-arena__reset" @click="${0}">Reset</button>`), this._handleReset) : '', this._renderSports(this.replayData));
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;
      var tabs = null;
      if (this.hideTabs === false) {
        tabs = html(_t44 || (_t44 = _`<div class="rtl-live-arena__tabs-container">
                <span class="rtl-live-arena__tabs ${0}" @click=${0}>Programm</span>
                <span class="rtl-live-arena__tabs ${0}" @click=${0}>Replay</span>
            </div>`), this.activeTab === "program" ? "rtl-live-arena__tabs--active" : "", function () {
          return _this10.changeTab("program");
        }, this.activeTab === "replay" ? "rtl-live-arena__tabs--active" : "", function () {
          return _this10.changeTab("replay");
        });
      }
      return html(_t45 || (_t45 = _`
            <style>${0}</style>
            ${0}
            ${0}
            ${0}
        `), css, tabs, this.renderProgramm(), this.renderReplay());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: Object
        },
        replayData: {
          type: Object
        },
        sortOrder: {
          type: String
        },
        types: {
          type: String
        },
        replayStartDate: {
          type: String
        },
        replayEndDate: {
          type: String
        },
        activeTab: {
          type: String
        },
        activeSportTypes: {
          type: Array
        },
        filterSportType: {
          type: String
        },
        hideTabs: {
          type: Boolean
        },
        aparttvMatches: {
          type: Array
        },
        language: {
          type: String
        }
      };
    }
  }]);
  return RTLLiveArena;
}(LitElement);
export { RTLLiveArena as default };
window.customElements.define('rtl-live-arena', RTLLiveArena);